export default {
    'Go to the next lesson': 'Go to the next lesson',
    'Listened': 'Listened',
    'Finish classwork': 'Finish classwork',
    'Educational material': 'Educational material',
    'upload_file': 'Upload file',
    'upload_file_title': 'Click or drag a file from your computer to download it',
    'upload_file_description': 'You can download PNG, SVG files. The maximum size is 5 GB',
    'remove': 'Remove',
    'save_files': 'Save',
    'file_uploaded_successfully': 'File uploaded successfully',
    'file_deleted_successfully': 'File deleted successfully',
    'enter_your_message': 'Enter your message here...',
    'group': 'Group',
    'small_lessons': 'lessons',
    'lessons_attended': 'The number of lessons attended ',
    "It was missed": "Missed",
    "It was visited": "Attended",
    'Total lessons': 'Total lessons',
    "Total classes": "Total classes",
    "Work on the platform" : "Work on the platform",
    "Course progress" : "Course progress",
    "Work in class" : "Work in class",
    "Programs" : "Programs",
    "Lessons" : "Lessons",
    "Your progress" : "Your progress",
    "Hide" : "Hide",
    "Missed Classes" : "Missed Classes",
    "Course textbooks": "Resources",
    "All lessons" : "All lessons",
    "Active tab" : "Active",
    "On checking" : "Under assessment",
    "Completed" : "Completed",
    "NameProgram": "Name",
    "Module" : "Module",
    "Status" : "Status",
    "Progress" : "Progress",
    "Additional materials" : "Additional materials",
    "Nothing to show": "Nothing to show",
    "Question": "Question",
    "Comment": "Comment",
    "Go to": "Go to",
    "Module Mark": "Average AofL",
    "Open a lesson": "Open a lesson",
    "Nothing to show or no filtering selected": "Nothing to show or no filtering selected",
};
